import { FunctionComponent } from 'react';
import styled from 'styled-components';

import { QnaDetailVo } from '@/types/qna';

import AnswerDetail, { AnswerDetailProps } from './AnswerDetail';

interface QnaAnswersProps extends Omit<AnswerDetailProps, 'answer'> {
  qnaDetail: QnaDetailVo;
  moveToHospitalDetail: (hospitalPid: string) => void;
}
const QnaAnswers: FunctionComponent<QnaAnswersProps> = ({
  qnaDetail,
  onShowModal,
  onClickLikeAnswer,
  onClickMagazine,
  moveToHospitalDetail,
  moveToDoctorDetailPage,
  onClickWriteReview,
}) => {
  return (
    <AnswerWrapper>
      <AnswerCount>
        {qnaDetail.category.name} 관련 {qnaDetail.answererCount}개의 답변
      </AnswerCount>

      <AnswerList>
        {qnaDetail.answers.map((answer) => (
          <AnswerDetail
            key={`qna_answer_${answer.answerPid}`}
            answer={answer}
            onShowModal={onShowModal}
            onClickLikeAnswer={onClickLikeAnswer}
            onClickMagazine={onClickMagazine}
            moveToHospitalDetail={moveToHospitalDetail}
            moveToDoctorDetailPage={moveToDoctorDetailPage}
            onClickWriteReview={onClickWriteReview}
          />
        ))}
      </AnswerList>
    </AnswerWrapper>
  );
};

export default QnaAnswers;

const AnswerWrapper = styled.div`
  min-height: 100%;
`;

const AnswerCount = styled.h2`
  padding: 8px 24px 24px;
  ${({ theme }) => `
    ${theme.typography.UI18SB};
    color: ${theme.color.gray800};
    background: ${theme.color.gray30}
  `}
`;

const AnswerList = styled.ul``;
